/**
 * Register the service worker and provide a {@link serviceWorker | controller}.
 *
 * @module
 */

/**
 * Since the controller is a singleton there is no class definition.
 *
 * @typedef {Exclude<ReturnType<setup>, null>} ServiceWorkerController
 */

import {navigator} from '@acng/frontend-bounty/dom/window.js';
import {guard, IS, OR} from '@acng/frontend-rubicon';
import {SWFile} from './service/env.js';
import {newObrienController} from './obrien-client.js';

const setup = () => {
  const {serviceWorker} = navigator;
  const registration = serviceWorker.register(SWFile);

  const catchError = async () => {
    try {
      await registration;

      return null;
    } catch (reason) {
      ASSERT: guard(reason, OR(IS(TypeError), IS(DOMException)));

      return reason;
    }
  };

  return {
    error: catchError(),
    obrien: newObrienController(registration),
  };
};

const serviceWorker = 'serviceWorker' in navigator ? setup() : null;

export {serviceWorker};
